export const RESSOURCES_ENDPOINTS = {
  attendances: `requests/leave`,
  attributes: `attributes/attributes`, //?fields={"name":1,"levels":1,"type":1}`,
  breaks: `breaks/breaks`,
  configs: `contact/configs`,
  contactTemplates: 'contact/templates',
  departments: `departments/departments`,
  hiringData: 'users/hiringData', //?fields={"name":1,"type":1}',
  holidays: `holidays/holidays`,
  permissions: `permissions/permissions`,
  positions: `structure/structure`, //?fields={"name":1}`,
  projectOwners: `projects/owners`,
  projects: `projects/projects`,
  punchRules: `punch/rules`,
  punchCardsThatNeedAction: `punch/cards/punchCardsThatNeedAction`,
  unpunchedShifts: `punch/cards/unpunchedShifts`,
  punchShifts: `punch/shifts`,
  requestFields: `requests/fields`,
  schedule: `schedule/schedule`,
  scheduleTemplates: `schedule/template`,
  scheduleTypes: `schedule/types`,
  tags: `tags/tags`, //?fields={"name":1,"type":1,"address":1}`,
  teams: `teams/teams`,
  userFilters: `users/filters`,
  userProcedures: `users/procedures`,
  users: 'users/users?showArchived=true', //?fields={"firstName":1,"lastName":1,"picture":1}'
  userSorts: `users/sorts`,
  userTemplates: 'users/templates',
  wagePremiums: `pay/wagePremiums`
} as const

export const USER_SETTING_API_END_POINT = 'setting'

export const STALE_TIME = 1000 * 60 * 60 // 1 hour
export const CACHE_TIME = 1000 * 60 * 60 * 8 // 8 hours
